import React, { useState } from 'react';
import { Label, FormGroup, Input, Col } from 'reactstrap';
import { HandLoadUnload, Dolly, Hazmat, PalletJack, Liftgate, Umbrella, Medical, TWIC, PPE } from '../../assets/svgs/ToolsAndEquipments';

const LoadRequirements = ({
    // State values
    isHandLoadUnload,
    isLiftgate,
    isPalletJack,
    isDolly,
    isHazmat,
    isTWICCard,
    isWeatherProtection,
    isMedical,
    isPPE,
    isHandLoadUnloadDisabled,
    isLiftgateDisabled,
    vehicleType,
    // Setters
    setIsHandLoadUnload,
    setIsLiftgate,
    setIsPalletJack,
    setIsDolly,
    setIsHazmat,
    setIsTWICCard,
    setIsWeatherProtection,
    setIsMedical,
    setIsPPE
}) => {
    // Local hover states
    const [isHandLoadUnloadHover, setIsHandLoadUnloadHover] = useState(false);
    const [isLiftgateHover, setIsLiftgateHover] = useState(false);
    const [isPalletJackHover, setIsPalletJackHover] = useState(false);
    const [isDollyHover, setIsDollyHover] = useState(false);
    const [isHazmatHover, setIsHazmatHover] = useState(false);
    const [isTWICCardHover, setIsTWICCardHover] = useState(false);
    const [isUmbrellaHover, setIsUmbrellaHover] = useState(false);
    const [isMedicalHover, setIsMedicalHover] = useState(false);
    const [isPPEHover, setIsPPEHover] = useState(false);

    const handleFill = name => {
        if (name === vehicleType) {
            return '#f7941d';
        } else {
            return '#5e72e4';
        }
    };

    return (
        <>
            <Col md="auto">
                <Label for="equipment_tools" style={{ textAlign: 'center', fontSize: '1.1em', display: 'block' }}>
                    <span
                        style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}
                    >
                        Load Requirements
                        <i className="fas fa-info-circle ml-1" style={{ fontSize: '1.2em' }} />
                    </span>
                </Label>
                <div style={{ marginTop: '12px', width: '420px', maxWidth: '100%', marginLeft: 'auto', marginRight: 'auto' }}>
                    <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', justifyContent: 'center' }}>
                        <div style={{ width: '48%' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>
                                <FormGroup check>
                                    <Label check style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <div onMouseEnter={() => setIsHandLoadUnloadHover(true)} onMouseLeave={() => setIsHandLoadUnloadHover(false)}>
                                            <HandLoadUnload name="HandLoadUnload" fill={isHandLoadUnloadDisabled ? '#333333' : '#5e72e4'}></HandLoadUnload>
                                        </div>
                                        {!isHandLoadUnloadDisabled && (
                                            <Input
                                                type="checkbox"
                                                id="tool-check"
                                                onChange={() => {
                                                    setIsHandLoadUnload(!isHandLoadUnload);
                                                }}
                                                disabled={isHandLoadUnloadDisabled}
                                                checked={isHandLoadUnload}
                                            />
                                        )}
                                        <span className="form-check-sign" style={{ marginLeft: 0 }} />
                                        {isHandLoadUnloadHover && 'Hand load'}
                                    </Label>
                                </FormGroup>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>
                                <FormGroup check>
                                    <Label check style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <div onMouseEnter={() => setIsLiftgateHover(true)} onMouseLeave={() => setIsLiftgateHover(false)}>
                                            <Liftgate name="Liftgate" fill={isLiftgateDisabled ? '#333333' : '#5e72e4'}></Liftgate>
                                        </div>
                                        {!isLiftgateDisabled && (
                                            <Input
                                                type="checkbox"
                                                id="tool-check"
                                                onChange={() => {
                                                    setIsLiftgate(!isLiftgate);
                                                }}
                                                disabled={isLiftgateDisabled}
                                                checked={isLiftgate}
                                            />
                                        )}
                                        <span className="form-check-sign" style={{ marginLeft: 0 }} />
                                        {isLiftgateHover && 'Liftgate'}
                                    </Label>
                                </FormGroup>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>
                                <FormGroup check>
                                    <Label check style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <div onMouseEnter={() => setIsPalletJackHover(true)} onMouseLeave={() => setIsPalletJackHover(false)}>
                                            <PalletJack name="PalletJack"></PalletJack>
                                        </div>
                                        <Input
                                            type="checkbox"
                                            id="tool-check"
                                            onChange={() => {
                                                setIsPalletJack(!isPalletJack);
                                            }}
                                            checked={isPalletJack}
                                        />
                                        <span className="form-check-sign" style={{ marginLeft: 0 }} />
                                        {isPalletJackHover && 'Pallet Jack'}
                                    </Label>
                                </FormGroup>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <FormGroup check>
                                    <Label check style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <div onMouseEnter={() => setIsDollyHover(true)} onMouseLeave={() => setIsDollyHover(false)}>
                                            <Dolly name="Dolly"></Dolly>
                                        </div>
                                        <Input
                                            type="checkbox"
                                            id="tool-check"
                                            onChange={() => {
                                                setIsDolly(!isDolly);
                                            }}
                                            checked={isDolly}
                                        />
                                        <span className="form-check-sign" style={{ marginLeft: 0 }} />
                                        {isDollyHover && 'Dolly'}
                                    </Label>
                                </FormGroup>
                            </div>
                        </div>

                        <div style={{ width: '48%' }}>
                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>
                                <FormGroup check>
                                    <Label check style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <div onMouseEnter={() => setIsHazmatHover(true)} onMouseLeave={() => setIsHazmatHover(false)}>
                                            <Hazmat name="Hazmat" fill={handleFill('Hazmat')}></Hazmat>
                                        </div>
                                        <Input
                                            type="checkbox"
                                            id="tool-check"
                                            onChange={() => {
                                                setIsHazmat(!isHazmat);
                                            }}
                                            checked={isHazmat}
                                        />
                                        <span className="form-check-sign" style={{ marginLeft: 0 }} />
                                        {isHazmatHover && 'Hazmat'}
                                    </Label>
                                </FormGroup>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>
                                <FormGroup check>
                                    <Label check style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <div onMouseEnter={() => setIsTWICCardHover(true)} onMouseLeave={() => setIsTWICCardHover(false)}>
                                            <TWIC name="TWIC" fill={handleFill('TWIC')}></TWIC>
                                        </div>
                                        <Input
                                            type="checkbox"
                                            id="tool-check"
                                            onChange={() => {
                                                setIsTWICCard(!isTWICCard);
                                            }}
                                            checked={isTWICCard}
                                        />
                                        <span className="form-check-sign" style={{ marginLeft: 0 }} />
                                        {isTWICCardHover && 'TWIC Card'}
                                    </Label>
                                </FormGroup>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>
                                <FormGroup check>
                                    <Label check style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <div onMouseEnter={() => setIsUmbrellaHover(true)} onMouseLeave={() => setIsUmbrellaHover(false)}>
                                            <Umbrella name="Umbrella"></Umbrella>
                                        </div>
                                        <Input
                                            type="checkbox"
                                            id="tool-check"
                                            onChange={() => {
                                                setIsWeatherProtection(!isWeatherProtection);
                                            }}
                                            checked={isWeatherProtection}
                                        />
                                        <span className="form-check-sign" style={{ marginLeft: 0 }} />
                                        {isUmbrellaHover && 'Weather Protection'}
                                    </Label>
                                </FormGroup>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <FormGroup check>
                                    <Label check style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <div onMouseEnter={() => setIsMedicalHover(true)} onMouseLeave={() => setIsMedicalHover(false)}>
                                            <Medical name="TWIC" fill={handleFill('TWIC')}></Medical>
                                        </div>
                                        <Input
                                            type="checkbox"
                                            id="tool-check"
                                            onChange={() => {
                                                setIsMedical(!isMedical);
                                            }}
                                            checked={isMedical}
                                        />
                                        <span className="form-check-sign" style={{ marginLeft: 0 }} />
                                        {isMedicalHover && 'Medical'}
                                    </Label>
                                </FormGroup>
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <FormGroup check>
                                <Label check style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <div onMouseEnter={() => setIsPPEHover(true)} onMouseLeave={() => setIsPPEHover(false)}>
                                        <PPE name="PPE" fill={handleFill('PPE')}></PPE>
                                    </div>
                                    <Input
                                        type="checkbox"
                                        id="tool-check"
                                        onChange={() => {
                                            setIsPPE(!isPPE);
                                        }}
                                        checked={isPPE}
                                    />
                                    <span className="form-check-sign" style={{ marginLeft: 0 }} />
                                    {isPPEHover && 'PPE'}
                                </Label>
                            </FormGroup>
                        </div>
                    </div>
                </div>
            </Col>
        </>
    );
};

export default LoadRequirements;
